var _path, _path2, _path3, _circle, _circle2, _path4, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 200 L120 100 L280 100 L280 200 Z",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 100 L200 60 L280 100",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 200 L200 230",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeDasharray: "4 4",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 235,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 2,
    fill: "#fbbf24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/anger.73f15348ccff0c133519e5fd3ed7b635.svg";
export { ForwardRef as ReactComponent };